import ReactDOM from "react-dom/client";
import "virtual:svg-icons-register";
import "@/initial.scss";
import "@/assets/font/iconfont.css";
import App from "@/App";
// import "@babel/polyfill"; // 影响FCP时间
import "@/styles/index.scss";
import "virtual:uno.css";
import "@fontsource/roboto";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/index.ts";
import "@/assets/js/amfe-flexible";
import { Provider } from "jotai";
import { jotaiStore } from "./atoms/store.ts";
import("./apm.ts");

useGoogleAdScript();
useYanDexScript();
useBeforeUnload();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <I18nextProvider i18n={i18n}>
    <Provider store={jotaiStore}>
      <App />
    </Provider>
  </I18nextProvider>,
);

console.table({
  应用名称: __PACKAGE_NAME__,
  应用版本: __PACKAGE_VERSION__,
  构建环境: __APP_ENV__,
  构建时间: __BUILD_TIME__,
  构建分支: __BUILD_GIT_BRANCH__,
});
